
import { Component } from '@angular/core';
import { BaseFormComponent } from '../base/base-form.component';

/**
 * 單檔的抽象類別，繼承 BaseFormComponent，暫時沒有額外的控制處理。
 *
 * @export
 * @abstract
 * @class SimpleSingleComponent
 * @extends {BaseFormComponent}
 */
@Component({
  template: ''
})
export abstract class SimpleSingleComponent extends BaseFormComponent {

}
